import { Controller } from "@hotwired/stimulus"

// À l'ouverture d'un <details>, défile en douceur vers le panneau révélé et
// focus son premier champ. Dégradation gracieuse : sans JS, le <details>
// s'ouvre normalement. Le décalage sous la nav fixe vient de `scroll-mt-*`.
export default class extends Controller {
  static targets = ["panel"]

  reveal() {
    if (!this.element.open) return

    this.panelTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    this.panelTarget.querySelector("input, textarea, select")?.focus({ preventScroll: true })
  }
}
